import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './routes/login/login.component';
import {HomeComponent} from './routes/home/home.component';
import {AuthenticatedGuard} from './shared/guards/authenticated.guard';
import {UserComponent} from './routes/home/user/user.component';
import {WebchargeComponent} from './routes/home/webcharge/webcharge.component';
import {PreorderComponent} from './routes/home/preorder/preorder.component';
import {PaycardsComponent} from './routes/home/paycards/paycards.component';


const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthenticatedGuard],
    children: [
      {
        path: 'users',
        component: UserComponent
      },
      {
        path: 'webcharges',
        component: WebchargeComponent
      },
      {
        path: 'paycards',
        component: PaycardsComponent
      },
      {
        path: 'preorders',
        component: PreorderComponent
      },
      {
        path: '**',
        redirectTo: 'paycards'
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
